import Paging from 'Features/Paging/paging'
import useQueryParams from 'Frontend/hooks/useQueryParams'
import { ICommunityNewsItem } from 'Frontend/scripts/models/communityNews.model'
import { getCommunityStartpage } from 'Frontend/scripts/services/startpage.services'
import { FunctionComponent, useEffect, useRef, useState } from 'react'
import CommunityStartPageItem from './CommunityStartPageItem'
import { IStartpageResult, IStartpageResultItem } from 'Frontend/scripts/models/startpage.model'
import { Spinner } from 'react-bootstrap'

type CommunityStartPageProps = {
  pageId: string
}

const CommunityStartPage: FunctionComponent<CommunityStartPageProps> = () => {
  const { getQueryParam } = useQueryParams()
  const [blogsAndNews, setBlogsAndNews] = useState<IStartpageResult | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [activePage, setActivePage] = useState<number>(
    getQueryParam('page') ? parseInt(getQueryParam('page') as string) : 1,
  )
  const startpageListRef = useRef<HTMLDivElement | null>(null)

  const getStartPageResult = () => {
    getCommunityStartpage(activePage).then((result) => {
      setBlogsAndNews(result)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    setIsLoading(true)
    getStartPageResult()
  }, [activePage])

  return (
    <div ref={startpageListRef}>
      {isLoading ? (
        <div className="py-3 d-flex justify-content-center align-items-center">
          <Spinner animation="border" role="status" variant="primary" />
        </div>
      ) : (
        blogsAndNews?.items?.map((item: IStartpageResultItem) => (
          <CommunityStartPageItem item={item} key={item.contentId} commentCollection={item.comments} />
        ))
      )}
      {blogsAndNews?.items && (
        <Paging
          activePage={activePage || 1}
          noOfPages={blogsAndNews.totalPages}
          callback={(pageIndex: number) => {
            setActivePage(pageIndex)
            startpageListRef?.current && startpageListRef.current.scrollIntoView()
          }}
        />
      )}
    </div>
  )
}

export default CommunityStartPage
